import $ from 'jquery';
globalThis.$ = $;
